import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy, SimpleChanges } from '@angular/core';


@Component({
  selector: 'app-map-pump-marker',
  templateUrl: './map-pump-marker.component.html',
  styleUrls: ['./map-pump-marker.component.scss']
})

export class MapPumpMarkerComponent implements OnInit, OnChanges {
    @Input() LstPumps = [];
    pumps = [];
    lat =null;
    lng = null;

    constructor() { }

    ngOnInit() {
        if(!this.lat && !this.lng){
            this.setCurrentLoc();
          }
    }

    setCurrentLoc(){
        navigator.geolocation.getCurrentPosition(loc=>{
          this.lat= loc.coords.latitude;
          this.lng = loc.coords.longitude;
        })
      }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.LstPumps) {
            this.LstPumps = changes.LstPumps.currentValue;
            this.LstPumps.forEach(location => {
                this.pumps.push(
                {
                    Lat: parseFloat(location.Lat),
                    Lng: parseFloat(location.Lng),
                    Location: location.Location,
                    PumpName: location.PumpName,
                    Status: location.Status
                });
            });
        }
    }
    GetStatus(status) {
        if(status == 1) {
            return true;
        }
        return false;
    }
}
